import React, {useState, useEffect, createContext} from 'react';
import axios from "@common/axios";

const ContentContext = createContext([{}, () => {}]);

const ContentProvider = (props) => {
    const {children} = props;
    const [content, setContent] = useState({});
    const [contentLoading, setContentLoading] = useState(false);
    const [contentSaving, setContentSaving] = useState(false);
    const [contentEditing, setContentEditing] = useState(false);
    const [mediaLocation, setMediaLocation] = useState('CONCEPT');
    const [dialogMediaObject, setDialogMediaObject] = useState(null);

    function updateCssStylesAndClasses(content) {
        if(content == undefined || content.currentSyllabus == undefined) {
            return;
        }

        const htmlBody = $('#edjin-body'),
            htmlBodyClass = htmlBody.attr("class"),
            syllabusId = htmlBody.data('syllabusId'),
            syllabusClass = htmlBody.data('syllabusClass'),
            buildNumber = htmlBody.data('buildNumber');

        if(htmlBodyClass == undefined || syllabusId == undefined) {
            return;
        }

        if(content.syllabusClass != undefined && syllabusClass != undefined && content.syllabusClass != syllabusClass) {
            htmlBody.attr('class', htmlBodyClass.replace(syllabusClass, content.syllabusClass));
            htmlBody.data('syllabusClass', content.syllabusClass);
        }

        if(syllabusId == content.currentSyllabus.syllabusId) {
            return;
        }

        const versionStr = '?version=' + buildNumber;
        if (content.syllabusGroupStyleSheet && content.syllabusGroupStyleSheet != '') {
            $("head link[id='syllabusGroupStyleSheet']").attr('href', content.syllabusGroupStyleSheet + versionStr);
        }
        if (content.syllabusGroupContentStyleSheet && content.syllabusGroupContentStyleSheet != '') {
            $("head link[id='syllabusGroupContentStyleSheet']").attr('href', content.syllabusGroupContentStyleSheet  + versionStr);
        }
        if (content.syllabusStyleSheet && content.syllabusStyleSheet != '') {
            $("head link[id='syllabusStyleSheet']").attr('href', content.syllabusStyleSheet  + versionStr);
        }
        if (content.syllabusContentStyleSheet && content.syllabusContentStyleSheet != '') {
            $("head link[id='syllabusContentStyleSheet']").attr('href', content.syllabusContentStyleSheet  + versionStr);
        }
        htmlBody.data('syllabusId', content.currentSyllabus.syllabusId);
    }

    const loadContent = () => {
        setContentLoading(true);
        closeDialogs();
        axios.get('/web/ui/session/public/content')
            .then(response => {
                setContent(response.data);
                updateCssStylesAndClasses(response.data);
                setContentLoading(false);
                if(response.data !== undefined && response.data.currentConcept !== undefined) {
                    localStorage.setItem("conceptId", response.data.currentConcept.conceptId);
                    localStorage.setItem("syllabusId", response.data.currentConcept.syllabusId);
                }
                
                if(globalReactFunctions !== undefined && response.data !== undefined) {
                    globalReactFunctions.currentConcept = response.data.currentConcept;
                }
            });
    }

    useEffect(() => {
        loadContent();
    }, []);

    if (globalReactFunctions !== undefined) {
        globalReactFunctions.setContentLoading = setContentLoading;
        globalReactFunctions.setContentSaving = setContentSaving;
        globalReactFunctions.setContentEditing = setContentEditing;
        globalReactFunctions.loadContent = loadContent;
        globalReactFunctions.mediaLocation = mediaLocation;
        globalReactFunctions.setMediaLocation = setMediaLocation;
        globalReactFunctions.setDialogMediaObject = setDialogMediaObject;
    }

    const context_values = {
        content,
        setContent,
        loadContent,
        contentLoading,
        setContentLoading,
        contentEditing,
        setContentEditing,
        contentSaving,
        setContentSaving,
        updateCssStylesAndClasses,
        mediaLocation,
        setMediaLocation,
        dialogMediaObject,
        setDialogMediaObject,
    }

    return (
        <ContentContext.Provider value={context_values}>
            {children}
        </ContentContext.Provider>
    );
}

export {ContentContext, ContentProvider};